export const whoispaul = `

#### How would you describe yourself?
I'm Johannes Paul Banks, but my friends call me Paul. I'm a business consultant in the government and commerce world. My hobbies are (kick)boxing and fitness. I was born in Suriname and raised in the Netherlands from the age of three.
<br />
<br />

#### What's the most rewarding part of helping people with diabetes through your work?
One of my inspirations for working at OSC is helping provide a solution for a safer, healthier, and freer life through open, accessible technology.
<br />
<br />

#### What have you learned about diabetes and open-source looping since joining the team?
This technology gives users peace of mind, supports caregivers, and makes advanced diabetes management available to everyone around the world, not only to those who are eligible for compensation based on health-insurance regulations and those who live in high-income countries.
<br />
<br />

#### Where do you see the future of diabetes over 10 years?
Today, people with diabetes often have to monitor their glucose levels and manage their insulin manually. In 10 years, that task should not require manual intervention. Parents should no longer lose sleep because they need to check their children's glucose levels at 3 a.m., and adults should not live in fear of a sudden low when they're at work or behind the wheel.
<br />
<br />

#### What is your contribution to OSC and the team?
This life-changing software has been used for more than 10 years. But to reach those in need, we need strong corporate governance to build trust and value, and that is where I come in.

With my background in business consulting, I focus on people, purpose, process, and performance. Effective governance requires the right people in the right roles with clear accountability. I ask questions like how well OSC meets its goals, uses resources, and fulfills its purpose, and I use this information to improve organizational processes.
<br />
<br />

<!-- blog-contact-footer -->
`;
